
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's1488e73779d7682f': `1) Åpne menyen i nettleseren din`,
's182ab2d6c997515f': `Legg den til på Hjem-skjermen din for å få en bedre brukeropplevelse og raskere tilgang.`,
's1b9047d53d9f9d22': `2) Trykk på Del-knappen i navigasjonslinjen`,
's2d90afa5dcca2c0e': `3) Rull ned til «Legg til på Hjem-skjerm»`,
's37a9e8aec5713460': `Mer`,
's4593f304dac8848c': `2) Trykk på "Legg til på Hjem-skjerm"`,
's54cfbb14f46396d4': `1) Åpne i hovednettleseren din`,
's6196153c4b0c1ea0': `Installer`,
's922329d6f6213590': `Legg til i Dock`,
'sa5ef80b4bb9b39f8': `Mindre`,
'sa7551383d1897fcc': `2) Velg Legg til i Dock`,
'sba52286c21552a4e': `Installer den på enheten din for å få en bedre brukeropplevelse og raskere tilgang.`,
'sc79fd7641eb9a975': `Skjul instruksjoner`,
'scdaf4bbff76674c8': `Legg til på Hjem-skjerm`,
'se740f75b95a51807': `Legg den til i Docken din for å få en bedre brukeropplevelse og raskere tilgang.`,
'sfea652f6580ff086': `Denne siden har app-funksjonalitet.`,
    };
  